
// popups.js (או איפה שזה יושב)

const Irreversible_popup = Object.freeze({
    isHtml: false,
    content: Object.freeze({
        he: `מהם אמצעי מניעה בלתי הפיכים?
קשירת צינור הזרע אצל גברים (ואזקטומי) - הליך כירורגי קצר שמתבצע בהרדמה מקומית או מלאה. ההליך לא משפיע על חשק מיני או זקפה. מדובר בהליך בלתי הפיך ברב המקרים.
קשירת או כריתת חצוצרות אצל נשים היא הליך ניתוחי שמטרתו למנוע את מעבר הביצית מהשחלה דרך החצוצרה לרחם, ובכך למנוע הריון באופן קבוע. ההליך אינו משפיע על המחזור החודשי או על רמות ההורמונים, אך הוא בלתי הפיך.`,
        ar: `ما هي وسائل منع الحمل غير القابلة للعكس؟

ربط القناة المنوية لدى الرجال (فازكتومي) هو إجراء جراحي قصير يُجرى تحت تخدير موضعي أو عام.
هذا الإجراء لا يؤثر على الرغبة الجنسية أو الانتصاب، ويُعتبر غير قابل للعكس في معظم الحالات.

ربط أو استئصال قناتي فالوب لدى النساء هو إجراء جراحي يهدف إلى منع انتقال البويضة من المبيض عبر قناة فالوب إلى الرحم، وبالتالي منع الحمل بشكل دائم.
هذا الإجراء لا يؤثر على الدورة الشهرية أو على مستويات الهرمونات، لكنه غير قابل للعكس.`
    })
});

const HormonalDoctor_popup = Object.freeze({
    isHtml: false,
    content: Object.freeze({
        he: `אם תשובתך היא "כן" בשאלה זו, כדאי לשוחח על כך עם הרופא.ה שלך לפני תחילת שימוש באמצעי מניעה הורמונליים.`,
        ar: `إذا كانت إجابتك "نعم" على هذا السؤال، فمن الأفضل التحدث مع طبيبتك/طبيبك قبل البدء باستخدام وسائل منع حمل هرمونية.`
    })
});

const HormonalInfo_popup = Object.freeze({
    isHtml: false,
    content: Object.freeze({
        he: `מהם אמצעי מניעה הורמונליים?
אלו שיטות למניעת היריון המבוססות על הורמונים (אסטרוגן ו/או פרוגסטין) הפועלות בעיקר בשלושה מנגנונים: דיכוי ביוץ, שינוי הרכב הריר הצווארי כך שיהיה בלתי חדיר לזרע ושינוי ברירית הרחם כך שיקשה על השתרשות היריון.
חשוב להיוועץ עם רופא/ת הנשים שלך לפני תחילת השימוש באמצעים הורמונליים.`,
        ar: `ما هي وسائل منع الحمل الهرمونية؟
هي طرق لمنع الحمل تعتمد على الهرمونات (الإستروجين و/أو البروجستين)، وتعمل بشكل أساسي عبر ثلاثة آليات: منع الإباضة، تغيير قوام مخاط عنق الرحم بحيث يصبح غير نافذ للحيوانات المنوية، وتغيير بطانة الرحم بحيث لا تسمح بانغراس الحمل.
من المهم استشارة طبيبة/طبيب النساء قبل البدء باستخدام وسائل منع الحمل الهرمونية.`
    })
});

const ResultGeneric_popup = Object.freeze({
    isHtml: true,
    content: Object.freeze({
        he: `<div style="display: flex; align-items: flex-start; gap: 8px; margin-bottom: 8px;">
  <img src="/icons/006-light-bulb.png" alt="tip" style="width: 24px; height: 24px;" />
  <span>קונדום הוא אמצעי המניעה היחיד שמגן מפני העברה של מחלות מין. גם במין אוראלי או אנאלי מומלץ להשתמש בקונדום.</span>
</div>
<div style="display: flex; align-items: flex-start; gap: 8px;">
  <img src="/icons/006-light-bulb.png" alt="tip" style="width: 24px; height: 24px;" />
  <span>במקרה של קיום יחסי מין לא מוגנים, או חשש מכשל באמצעי המניעה עומדים לרשותך
    <a href="https://www.wtb.org.il/emergency/" target="_blank" rel="noopener noreferrer" class="underline text-accent">אמצעים לשעת חרום</a>
  </span>
</div>`,
        ar: `<div style="display: flex; align-items: flex-start; gap: 8px; margin-bottom: 8px;">
  <img src="/icons/006-light-bulb.png" alt="tip" style="width: 24px; height: 24px;" />
  <span>من المهم أن تعلمي أن الواقي الذكري هو وسيلة منع الحمل الوحيدة التي تحمي من الأمراض المنقولة جنسيًا. حتى إذا كنتِ تمارسين علاقات جنسية لا يمكن أن تؤدي إلى الحمل (مثل الجنس الفموي أو الشرجي)، فإننا نوصي بالاستمرار في استخدام الواقي الذكري لتجنّب العدوى بالأمراض المنقولة جنسيًا.</span>
</div>
<div style="display: flex; align-items: flex-start; gap: 8px;">
  <img src="/icons/006-light-bulb.png" alt="tip" style="width: 24px; height: 24px;" />
  <span>في حال حدوث علاقة جنسية غير محمية، أي دون استخدام وسيلة منع حمل أو في حال فشل وسيلة منع الحمل (مثل تمزّق الواقي الذكري)، نود تذكيرك بأن هناك أيضًا <a href="https://www.wtb.org.il/emergency/" target="_blank" rel="noopener noreferrer" class="underline text-accent">وسائل منع حمل طارئة</a> متاحة لكِ.</span>
</div>`
    })
});

export const popupTriggers = Object.freeze({
    // Irreversible popup triggers
    q_154: Irreversible_popup,
    q_153: Irreversible_popup,
    q_152: Irreversible_popup,
    q_151: Irreversible_popup,
    q_150: Irreversible_popup,
    q_149: Irreversible_popup,
    q_143: Irreversible_popup,
    q_142: Irreversible_popup,
    q_141: Irreversible_popup,
    q_136: Irreversible_popup,
    q_135: Irreversible_popup,
    q_134: Irreversible_popup,
    q_133: Irreversible_popup,
    q_130: Irreversible_popup,
    q_129: Irreversible_popup,
    q_128: Irreversible_popup,
    q_127: Irreversible_popup,
    q_124: Irreversible_popup,
    q_123: Irreversible_popup,
    q_116: Irreversible_popup,
    q_115: Irreversible_popup,
    q_114: Irreversible_popup,
    q_113: Irreversible_popup,
    q_110: Irreversible_popup,
    q_109: Irreversible_popup,
    q_108: Irreversible_popup,
    q_107: Irreversible_popup,
    q_104: Irreversible_popup,
    q_103: Irreversible_popup,
    q_102: Irreversible_popup,
    q_101: Irreversible_popup,
    q_96: Irreversible_popup,
    q_95: Irreversible_popup,
    q_94: Irreversible_popup,
    q_93: Irreversible_popup,
    q_90: Irreversible_popup,
    q_89: Irreversible_popup,
    q_88: Irreversible_popup,
    q_87: Irreversible_popup,
    q_84: Irreversible_popup,
    q_83: Irreversible_popup,
    q_82: Irreversible_popup,
    q_81: Irreversible_popup,
    q_70: Irreversible_popup,
    q_69: Irreversible_popup,
    q_68: Irreversible_popup,
    q_67: Irreversible_popup,
    q_64: Irreversible_popup,
    q_63: Irreversible_popup,
    q_62: Irreversible_popup,
    q_61: Irreversible_popup,
    q_58: Irreversible_popup,
    q_57: Irreversible_popup,
    q_56: Irreversible_popup,
    q_55: Irreversible_popup,
    q_50: Irreversible_popup,
    q_49: Irreversible_popup,
    q_48: Irreversible_popup,
    q_47: Irreversible_popup,
    q_44: Irreversible_popup,
    q_43: Irreversible_popup,
    q_42: Irreversible_popup,
    q_41: Irreversible_popup,
    q_38: Irreversible_popup,
    q_37: Irreversible_popup,
    q_36: Irreversible_popup,
    q_35: Irreversible_popup,
    q_19: Irreversible_popup,
    q_18: Irreversible_popup,
    q_17: Irreversible_popup,
    q_16: Irreversible_popup,
    q_13: Irreversible_popup,
    q_12: Irreversible_popup,
    q_11: Irreversible_popup,
    q_10: Irreversible_popup,

    // Hormonal warnings/info
    q_29: HormonalDoctor_popup,
    q_75: HormonalDoctor_popup,
    q_2: HormonalInfo_popup,

    // Result generic tips
    result_generic: ResultGeneric_popup
});